/* eslint @ngrx/prefer-effect-callback-in-block-statement: off */
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { map } from 'rxjs';

import { selectCompanyId } from '../company/company-state.selectors';

import { BannerNotificationActions } from './banner-notification.actions';
import { BannerNotificationEventName } from './banner-notification.event-name.type';

@Injectable()
export class BannerNotificationStateEffects {
  private readonly actions$ = inject(Actions);
  private readonly store = inject(Store);
  private readonly router = inject(Router);

  dismissBanner$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(BannerNotificationActions.dismissBanner),
        concatLatestFrom(() => this.store.select(selectCompanyId)),
        map(([_, companyId]) => {
          switch (_.banner?.bannerNotificationEventName) {
            case BannerNotificationEventName.trialBanner:
              const now = new Date();
              localStorage.setItem(
                `${_.banner.bannerNotificationEventName}-BannerLastDismissedDate-${companyId}`,
                `${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()}`
              );
              break;
          }
          return BannerNotificationActions.dismissBannerSuccess();
        })
      ),
    { dispatch: true }
  );

  bannerActionClicked$ = createEffect(() =>
    this.actions$.pipe(
      ofType(BannerNotificationActions.bannerActionClicked),
      map(({ banner }) => {
        if (banner?.action) return banner.action;
        this.router.navigateByUrl(banner.actionRoute);
      })
    )
  );
}
